import React, { FC } from 'react'

import { Photos } from 'components/page/ForeignProfile/common.types'
import { PhotosTileLastBlockView } from 'components/page/ForeignProfile/Photos/PhotosTile/PhotoTileLastBlock/PhotosTileLastBlockView'

export const PhotosTileLastBlock: FC<{
  restPhotos: Photos
}> = ({ restPhotos }) => {
  const {
    photoId,
    urls: { huge },
    faceCenter,
    width,
    height,
  } = restPhotos[0]

  return (
    <PhotosTileLastBlockView
      photoId={photoId}
      photoUrl={huge}
      coordinates={faceCenter}
      width={width}
      height={height}
      count={restPhotos.length}
    />
  )
}
